module.exports = __webpack_public_path__ + "img/Sajdak2.6be913a4.webp";